// src/redux/slices/ghlStaffCalendarSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../constants/config";
import { filterTestPractitioners } from "../../utils/practitioners";

// Fetch staff with calendars
export const fetchGHLStaffWithCalendars = createAsyncThunk(
  "ghlStaffCalendar/fetchStaff",
  async (options = {}, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/user/staff/calendars`);
      return response.data.staff || [];
    } catch (error) {
      console.error("Error fetching staff with calendars:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
  {
    condition: (options = {}, { getState }) => {
      const { ghlStaffPractitioners } = getState();

      // If force reload is requested, always fetch
      if (options.force) {
        return true;
      }

      // Don't fetch if data already exists or loading is in progress
      if (ghlStaffPractitioners.data?.length > 0 || ghlStaffPractitioners.loading) {
        return false;
      }

      return true;
    },
  }
);

const ghlStaffCalendarSlice = createSlice({
  name: "ghlStaffPractitioners",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGHLStaffWithCalendars.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGHLStaffWithCalendars.fulfilled, (state, action) => {
        state.loading = false;
        state.data = filterTestPractitioners(action.payload);
      })
      .addCase(fetchGHLStaffWithCalendars.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default ghlStaffCalendarSlice.reducer;
